<template>
  <div>
    <CCard>
      <CCardHeader>
        <span class="font-weight-bold">
          <CIcon name="cilStar" />
          Danh sách Kho
        </span>
        <CButton
          color="success"
          size="sm"
          class="float-right"
          v-if="isAdmin"
          @click.prevent="
            (e) => {
              editing = true;
              warehouseId = 0;
            }
          "
        >
          <CIcon name="cil-plus" />
          Thêm Kho
        </CButton>
      </CCardHeader>
      <CCardBody>
        <CRow>
          <CCol md="4">
            <CSelect
              label="Trạng thái"
              placeholder="Trạng thái"
              :value.sync="warehouseStatus"
              :options="
                Object.keys(statusList).map((_) => {
                  return {
                    value: _,
                    label: statusList[_],
                  };
                })
              "
              :horizontal="{
                label: 'col-4 text-right',
                input: 'col-8',
              }"
            />
          </CCol>
          <CCol md="4">
            <CInput
              label="Tên Kho"
              placeholder="Tên Kho"
              v-model="warehouseName"
              :horizontal="{
                label: 'col-4 text-right',
                input: 'col-8',
              }"
              @keyup.enter="doFilter"
            />
          </CCol>
          <CCol md="3" class="text-center">
            <CButton color="primary" class="mr-2 mb-3" @click="doFilter">
              <CIcon name="cil-search" custom-classes="c-icon m-0" />
              Tìm kiếm
            </CButton>

            <CButton color="secondary" class="mb-3" @click="clear">
              <CIcon name="cil-x-circle" custom-classes="c-icon m-0" />
              Đặt lại
            </CButton>
          </CCol>
        </CRow>
        <odata-table
          ref="lstWarehouse"
          url="odata/InventoryWarehouse"
          :filter="filter"
          select="Id,Name,Address,AgencyId,Status,CreatedAt"
          sortBy="CreatedAt desc"
          :expand="`Agency($select=Name)`"
          :pageSize="pageSize"
          :colSetting="{
            Action: {
              display: '#',
              sortable: false,
              style: 'min-width: 50px;',
            },
            Name: {
              field: 'Name',
              display: 'Tên Kho',
              sortable: true,
              style: 'min-width: 150px',
            },
            Address: {
              field: 'Address',
              display: 'Địa chỉ',
              sortable: true,
              style: 'min-width: 200px',
            },
            AgencyName: {
              field: 'Agency/Name',
              display: 'Cửa Hàng',
              sortable: true,
              style: 'min-width: 120px',
            },
            Status: {
              field: 'Status',
              display: 'Trạng thái',
              sortable: true,
              style: 'min-width: 100px',
            },
            CreatedAt: {
              field: 'CreatedAt',
              display: 'Ngày tạo',
              sortable: true,
              style: 'min-width: 120px',
            },
          }"
        >
          <template v-slot:tbody="{ rows }">
            <tr v-for="(row, i) in rows" :key="`tr-${i}`">
              <td>{{ i + 1 + ($refs.lstWarehouse.page - 1) * pageSize }}.</td>
              <td>
                <a
                  href="javascript:"
                  class="text-primary"
                  :title="`Cập nhật: ${row.Name}`"
                  @click="
                    (e) => {
                      warehouseId = row.Id;
                      editing = true;
                    }
                  "
                >
                  <CIcon name="cil-pencil" />
                  {{ row.Name }}
                </a>
              </td>
              <td class="text-truncate" style="max-width:200px;">
                <span :title="row.Address">
                  {{ row.Address }}
                </span>
              </td>
              <td>
                <span v-if="row.Agency">{{ row.Agency.Name }}</span>
              </td>
              <td>
                <CBadge :color="getBadge(row.Status)">
                  {{ $const.STATUS_TEXT[row.Status] }}
                </CBadge>
              </td>
              <td>
                {{
                  $moment
                    .utc(row.CreatedAt)
                    .local()
                    .format("DD/MM/YY HH:mm")
                }}
              </td>
            </tr>
          </template>
        </odata-table>
      </CCardBody>
    </CCard>
    <detail
      :editing.sync="editing"
      :warehouseId.sync="warehouseId"
      @reload="$refs.lstWarehouse.loadData()"
    />
  </div>
</template>

<script>
import odataTable from "@/components/odataTable.vue";
import detail from "./Detail.vue";

export default {
  name: "Warehouse",
  components: {
    odataTable,
    detail,
  },
  data() {
    return {
      editing: false,
      warehouseId: 0,
      pageSize: 10,
      warehouseStatus: this.$const.STATUS.Active.toString(),
      statusList: this.$const.STATUS_TEXT,
      warehouseName: null,
      filters: null,
    };
  },
  computed: {
    filter() {
      let filters = [];

      if (this.filters && this.filters.length) {
        filters = [...this.filters];
      }

      return filters.join(" and ");
    },
    isAdmin() {
      let authUser = this.$user.getters.authUser;
      return authUser
        ? authUser && authUser.role == this.$const.ROLES.SuperAdmin
        : false;
    },
  },
  methods: {
    getBadge(status) {
      switch (status) {
        case this.$const.STATUS.Active:
          return "success";
        case this.$const.STATUS.InActive:
          return "secondary";
        default:
          "primary";
      }
    },
    doFilter() {
      let filters = [];
      this.warehouseStatus && filters.push(`Status eq ${this.warehouseStatus}`);
      this.warehouseName &&
        filters.push(`contains(Name,'${this.warehouseName}')`);
      filters.join(" and ");

      if (JSON.stringify(this.filters) != JSON.stringify(filters)) {
        this.filters = filters;
      } else {
        this.$refs.lstWarehouse.loadData();
      }
    },
    clear() {
      this.warehouseStatus = this.$const.STATUS.Active.toString();
      this.warehouseName = null;
    },
  },
};
</script>
